import React from 'react';

export const DotSeparator:React.FC = () => <div className="myinterview-widget__dot-separator" />;
